import { createContext, useContext } from 'react';

interface ImageSelectContextValue {
  onSelect?: (src: string) => void;
}

export const ImageSelectContext = createContext<ImageSelectContextValue>({});

export const useImageSelect = () => useContext(ImageSelectContext);
